import TBCH from "../static/tbch logo.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { PulseLoader } from 'react-spinners';

export default function Message() {
    const { username } = useParams();
    const [search, setSearch] = useState(true);
    const [found, setFound] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [userData, setUserData] = useState("");
    const [message, setMessage] = useState("");
    const [load, setLoad] = useState(false);


    useState(() => {
        document.title = "Send Message | TBCH";
        axios.post("/_tbch-api/search", { name : username })
        .then(d => {
           if (!d.data.success) {
               setSearch(false);
               return setFound(false);
           } else {
               setSearch(false);
               setFound(true);
               document.title = `Send secret messages to ${userData}! | TBCH"`;
               return setUserData(d.data.message);
           }
        })
        .catch(e => {
            alert("Can't connect to server.")
        })
    }, [])

    const handleMessageChange = (e) => {
        return setMessage(e.target.value);
    }

    const handleSubmitMessage = (e) => {
        e.preventDefault();
        setLoad(true);
        axios.post("/_tbch-api/send", { name : username, message : message.trim() })
             .then(d => {
                setSubmit(true);
                setLoad(false);
             })
             .catch(e => {
                alert("Can't connect to server.")
                setLoad(false);
             })
    }

    const reload = () => {
        return window.location.reload();
    }

    return (
        <div className="main">
            <section className="message-page bg-src">
            <div className="darken">

            </div>
            <nav className="nav-bar">
                <div className="container">
                    <div className="logo">
                        <img src={TBCH} alt="" />
                    </div>                    
                </div>
            </nav>
                <div className="container">
                    <div className="main-message">
                        <div className="message">
                            <h1>👀</h1>
                            <h3>{search ? "Searching user..." : found ? userData : "User not found."}</h3>
                            <div className="inputs" style={found && !submit ? {display : "block"} : {display : "none"}}>
                                <span className="title">Tell me something!</span>
                                <form onSubmit={handleSubmitMessage}>
                                    <input type="text" name="message" className="message-input" onChange={handleMessageChange} required placeholder="Something good, please."/>
                                    <button type="submit" className="submit-btn">{load ? <PulseLoader color={"#FFFFFF"} loading={load} size={5} /> : "Send"}</button>
                                </form>
                                
                            </div>
                            <div className="onSuccess"  style={submit ? {display : "flex"} : {display : "none"}}>
                                <span>Message sent!</span>
                                <span className="send-anot" onClick={reload}>Send another?</span>
                            </div>
                            
                            <span className="join"><Link to="/register">Join TBCH!</Link></span>
                        </div>
                    </div>
                </div>
            </section>
            
        </div>
    )
}